<template>
    <div v-if="selectedRules.length > 0">
        <p class="mb-2" v-if="!compact">{{ translate("page.admin_academy_results.your_rules") }}</p>
        <div class="columns is-multiline">
            <div v-for="(selectedRule, index) in props.selectedRules" class="column" :class="{ 'is-narrow': !compact }" :key="index">
                <div class="box is-flex is-align-items-center" :class="{ 'is-condensed': compact }">
                    <ScoreForAwardedMedalsRuleView v-if="selectedRule.rule === 'scoreForAwardedMedals'" :rule-data="selectedRule" />

                    <ScoreForWonMatchesRuleView v-if="selectedRule.rule === 'scoreForWonMatches'" :rule-data="selectedRule" />

                    <button v-if="!readOnly" class="button is-small is-danger ml-3" @click="removeRule(index)" :disabled="!canDelete">
                        <span class="icon">
                            <i class="fas fa-times" />
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="has-text-warning">
        <span class="icon">
            <i class="fa fa-exclamation-triangle" />
        </span>
        <span>{{ translate("page.admin_academy_results.no_rules_configured") }}</span>
    </div>
</template>

<script setup lang="ts">
    import { useAcademyResultsStore } from "../../academyResultsStore";
    import { computed } from "vue";
    import ScoreForAwardedMedalsRuleView from "./ScoreForAwardedMedalsRuleView.vue";
    import { translate } from "../../../Common/translations";
    import { SelectedRule } from "../../../Api/competitorResultsApi";
    import ScoreForWonMatchesRuleView from "./ScoreForWonMatchesRuleView.vue";

    const store = useAcademyResultsStore();

    const props = defineProps<{
        selectedRules: SelectedRule[];
        compact?: boolean;
        readOnly?: boolean;
    }>();

    const canDelete = computed(() => !store.publishingMode);

    function removeRule(index: number) {
        store.removeRule(index);
    }
</script>

<style scoped></style>
